import { useQuery } from '@apollo/client/react'
import { Slimline as Error } from '@/components/error'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { graphql } from '@/gql'
import { useEffect, useRef } from 'react'
import { Connector } from './connector'

const ConnectorsQuery = graphql(`
  query Connectors($filters: ConnectorFilters, $order: ConnectorOrder, $after: String) {
    connectors(filters: $filters, order: $order, after: $after, first: 40) {
      nodes {
        id
        name
        svg
        connectorPins { id svg connectorFamilyPin { id name role } }
      }
      count
      pageInfo { hasNextPage hasPreviousPage startCursor endCursor }
    }
  }
`)

export const Connectors = () => {
  const { data, loading, error } = useQuery(ConnectorsQuery)

  const timeout = useRef<NodeJS.Timeout>(null)

  useEffect(() => {
    timeout.current = setInterval(() => {
      const pin = document.getElementById('c314a877-98d4-4088-bcca-e8c81c5db4e5-94c008f4-96de-43f0-a2d5-6e95abe275e8')
      if (pin) {
        const color = pin.getAttribute('stroke')
        console.log(color)
        if (color === 'red') {
          pin.setAttribute('stroke', 'white')
        } else {
          pin.setAttribute('stroke', 'red')
        }
      }
    }, 300)

    return () => {
      if (timeout.current) {
        clearInterval(timeout.current)
      }
    }
  }, [])

  if (loading) return <LoadingSkeleton table />

  return (
    <>
      { error && <Error error={ error } /> }
      { data && <div className="grid grid-cols-4 gap-3 items-center">
        { data.connectors.nodes.map(connector => <Connector connector={ connector } />) }
      </div> }
    </>
  )
}
